import React, { useEffect, useState, useRef, useCallback } from 'react';
import Layout from '../../components/layout/Layout';
import { getData, postData, putData, deleteData, postDataWithFile, downloadCSV } from '../../services/apiService';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
    IconButton, Button, Modal, TextField, Select, MenuItem, Pagination, InputAdornment, InputLabel, FormControl, Tooltip, Alert
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Switch from '@mui/material/Switch';
import useDebounce from '../../hooks/useDebounce';
import Progress from '../../hooks/useProgressBar';
import useFetchIp from "../../hooks/useFetchIp";
import DownloadIcon from '@mui/icons-material/Download';

const Users = () => {
    const [exportLoading, setExportLoading] = useState(false);
    const { ip } = useFetchIp();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const isFetched = useRef(false);
    const [formData, setFormData] = useState({
        firstName: '', lastName: '', email: '', phone: '', employee_id: '', adhaar: '',
        password: '', confirmPassword: '', department_id: null, college_id: '', role_id: '', affiliatedCollegeCode: '', affiliatedCollegeName: '', gender: ''
    });
    const [errors, setErrors] = useState({});
    const [showStudentModal, addStudentShowModal] = useState(false);
    const [updateStudentModalShow, updateStudentModal] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [DepartmentData, setDepartments] = useState([]);
    const [collegeData, setCollege] = useState([]);
    const [roleData, setRole] = useState([]);
    const ErrorMessage = ({ error }) => (
        error ? <div className="text-danger small mt-1">{error}</div> : null
    );
    const [userType, setUserType] = useState('Students');
    const [progressFilter, setProgressFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    // Pagination and search states
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const debouncedSearchQuery = useDebounce(searchQuery, 500);
    const [selectedCollege, setSelectedCollege] = useState('');
    // const [monthFilter, setMonthFilter] = useState('');
    // const [yearFilter, setYearFilter] = useState('');

    const currentYear = new Date().getFullYear();

    const [yearFilter, setYearFilter] = useState(currentYear.toString());
    const [monthFilter, setMonthFilter] = useState('');
    const [excelImportStatus, setExcelImportStatus] = useState(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getData(`/get-student-instructors?page=${page}&limit=${rowsPerPage}&search=${debouncedSearchQuery}&college_id=${selectedCollege}&progressStatus=${progressFilter}&isApproved=${statusFilter}&month=${monthFilter}&year=${yearFilter}`);
            if (response) {
                setData(response.data);
                setTotalPages(response.totalPages);
            }
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch data', error);
            setLoading(false);
        }
    }, [page, rowsPerPage, debouncedSearchQuery, selectedCollege, progressFilter, statusFilter, monthFilter, yearFilter]);

    const getCollege = useCallback(async () => {
        try {
            const response = await getData(`/get-colleges-for-dropdown`);
            if (response) {
                setCollege(response);
            }
        } catch (error) {
            console.error('Failed to fetch data', error);
        }
    }, []);


    const getRole = useCallback(async () => {
        try {
            const response = await getData(`get-role-for-dropdown`);
            if (response) {
                setRole(response);
                // Set default role if not already set and roles exist
                if (!formData.role_id && response.length > 0) {
                    setFormData(prev => ({ ...prev, role_id: response[0]._id }));
                }
            }
        } catch (error) {
            console.error('Failed to fetch data', error);
        }
    }, [formData.role_id]);

    // Add function to fetch departments by college
    const getDepartmentsByCollege = async (collegeId) => {
        try {
            const response = await getData(`/get-departments-by-college/${collegeId}`);
            if (response) {
                setDepartments(response);
            }
        } catch (error) {
            console.error('Failed to fetch departments', error);
        }
    };

    // useEffect(() => {
    //     if (!isFetched.current) {
    //         fetchData();
    //         getCollege();
    //         getRole();
    //     }
    // }, [fetchData, getCollege, getRole]);

    useEffect(() => {
        fetchData();
    }, [
        page,
        rowsPerPage,
        debouncedSearchQuery,
        selectedCollege,
        progressFilter,
        statusFilter,
        monthFilter,
        yearFilter
    ]);

    useEffect(() => {
        getCollege();
        getRole();
    }, []);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setPage(1); // Reset to first page on new search
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(event.target.value);
        setPage(1);
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (name === 'role_id') {
            const rollName = roleData.find(role => role._id === value)?.role_name;
            setUserType(rollName);
        }
        if (name === 'college_id') {
            getDepartmentsByCollege(value);
            setFormData(prev => ({ ...prev, department_id: null }));
        }
    };
    // Add new College!
    const addStudent = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await postData('/add-student-instructors', formData);
            setFormData({
                firstName: '', lastName: '', email: '', phone: '', employee_id: '', adhaar: '',
                password: '', confirmPassword: '', department_id: null, college_id: '', role_id: '', affiliatedCollegeCode: '', affiliatedCollegeName: '', gender: ''
            });
            setErrors([]);
            addStudentShowModal(false);
            fetchData();
            setLoading(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                // Convert array of errors to object with field names as keys
                const errorsObj = {};
                error.response.data.errors.forEach(err => {
                    errorsObj[err.path] = err.msg;
                });
                setErrors(errorsObj);
                setTimeout(() => {
                    setErrors({});
                }, 3000);
            }
            setLoading(false);
        }
    };

    // Edit Subject
    const editStudent = (id) => {
        const studentData = data.find(college => college._id === id);
        setSelectedStudent(studentData);
        // Fetch departments for the selected college
        if (studentData?.college_id?._id) {
            getDepartmentsByCollege(studentData.college_id._id);
        }
        updateStudentModal(true);
    };

    const handleStatusChange = async (id, newStatus) => {
        try {
            // Update the status in your state
            setData(data.map(item =>
                item._id === id ? { ...item, isApproved: newStatus } : item
            ));
            await putData(`/update-student-instructors/${id}`, { isApproved: newStatus });
        } catch (error) {
            console.error('Failed to update status:', error);
            setData(data.map(item =>
                item._id === id ? { ...item, isApproved: !newStatus } : item
            ));
        }
    };
    // Update Subject
    const updateStudent = async () => {
        if (!selectedStudent) return;

        const updatedData = {
            firstName: selectedStudent.firstName,
            lastName: selectedStudent.lastName,
            email: selectedStudent.email,
            phone: selectedStudent.phone,
            adhaar: selectedStudent.adhaar,
            employee_id: selectedStudent.employee_id,
            department_id: selectedStudent?.department_id?._id || selectedStudent.department_id,
            college_id: selectedStudent?.college_id?._id || selectedStudent.college_id,
            role_id: selectedStudent?.role_id?._id || selectedStudent.role_id,
            affiliatedCollegeCode: selectedStudent.affiliatedCollegeCode,
            affiliatedCollegeName: selectedStudent.affiliatedCollegeName,
            gender: selectedStudent.gender,
            isApproved: selectedStudent.isApproved
        };

        try {
            await putData(`/update-student-instructors/${selectedStudent._id}`, updatedData);
            fetchData();
            updateStudentModal(false);
            setSelectedStudent(null); // Reset selected student after update
        } catch (error) {
            if (error.response?.data?.errors) {
                const errorsObj = {};
                error.response.data.errors.forEach(err => {
                    errorsObj[err.path] = err.msg;
                });
                setErrors(errorsObj);
            }
            console.error('Failed to update student', error);
        }
    };

    // Delete College!
    const deleteStudent = async (id) => {
        try {
            // await deleteData(`/delete-student-instructors/${id}`);
            await deleteData(`/delete-student-instructors/${id}/${ip}`);
            await fetchData();
        } catch (error) {
            console.error("Error:", error);
        }
    };

    // For Add Voucher Modal
    const handleAddStudentModalClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        addStudentShowModal(false);
    };

    // For Update Voucher Modal
    const handleUpdateStudentModalClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        updateStudentModal(false);
    };

    // Excel Upload Function (background job + polling — same as institute login)
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    const handleExcelUpload = async (e) => {
        const file = e.target.files[0];
        e.target.value = '';
        if (!file) return;
        const excelForm = new FormData();
        excelForm.append("file", file);
        try {
            setExcelImportStatus('Uploading file…');
            const res = await postDataWithFile("admin-upload-student", excelForm);
            const jobId = res?.jobId;
            if (!jobId) {
                setExcelImportStatus(null);
                await fetchData();
                alert(res?.message || 'Import acknowledged.');
                return;
            }
            setExcelImportStatus('Import running on server…');
            const maxAttempts = 7200;
            const intervalMs = 2000;
            for (let attempt = 0; attempt < maxAttempts; attempt++) {
                await sleep(intervalMs);
                const job = await getData(`upload-students/job/${jobId}`);
                if (job.chunksTotal > 0) {
                    setExcelImportStatus(
                        `Import in progress: chunk ${job.chunksProcessed || 0} of ${job.chunksTotal} (${job.totalRows || 0} rows)`
                    );
                }
                if (job.status === 'completed') {
                    setExcelImportStatus(null);
                    await fetchData();
                    alert(
                        `Import finished.\nSaved: ${job.totalSaved}\nDuplicates / skipped: ${job.totalDuplicates}\nRow errors: ${job.totalErrors}`
                    );
                    return;
                }
                if (job.status === 'failed') {
                    setExcelImportStatus(null);
                    alert(job.errorMessage || 'Import failed on the server.');
                    return;
                }
            }
            setExcelImportStatus(null);
            alert('Stopped checking import status after a long wait. Refresh the list later — the import may still be running.');
        } catch (error) {
            console.error("Error uploading file:", error);
            setExcelImportStatus(null);
            alert(error.response?.data?.message || 'Failed to import students');
        }
    };

    const clearFilters = () => {
        setStatusFilter('');
        setProgressFilter('');
        setSearchQuery('');
        setSelectedCollege('');
        setPage(1);
        setMonthFilter('');
        setYearFilter('');
    };


    const handleExportCSV = () => {
        if (!data || data.length === 0) {
            alert("No data to export");
            return;
        }

        const headers = [
            "Full Name",
            "College",
            "Email",
            "Student ID",
            "Month",
            "Year",
            "Status",
            "Progress Status",
            "Course Progress",
            "Assessment %"
        ];

        const rows = data.map(item => [
            `"${item.firstName} ${item.lastName}"`,
            `"${item.affiliatedCollegeName}"`,
            `"${item.email}"`,
            `"${item.employee_id}"`,
            `"${new Date(item.createdAt).toLocaleString('default', { month: 'long' })}"`,
            `"${new Date(item.createdAt).getFullYear()}"`,
            `"${item.isApproved ? "Approved" : "Unapproved"}"`,
            `"${item.progressStatus}"`,
            `"${item.progressPercentage}%"`,
            `"${item.quizPercentage}%"`
        ]);

        let csvContent =
            "data:text/csv;charset=utf-8," +
            [headers.map(h => `"${h}"`), ...rows]
                .map(e => e.join(","))
                .join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.href = encodedUri;
        link.download = "students_data.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const handleExportAllCSV = async () => {
        try {
            setExportLoading(true);

            const response = await downloadCSV(
                `/export-college-students-csv?search=${searchQuery}&isApproved=${statusFilter}&month=${monthFilter}&college_id=${selectedCollege}&progressStatus=${progressFilter}&year=${yearFilter}`
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement("a");
            link.href = url;
            link.download = "students_all_data.csv";

            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error(error);
            alert("Failed to export CSV");
        } finally {
            setExportLoading(false);
        }
    };

    return (
        <Layout>
            {exportLoading && <Progress />}
            {loading ? <Progress /> :
                <Box className="p-4 sm:p-6 bg-gray-100 min-h-screen" sx={{ width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: { xs: "flex-start", md: "center" },
                            mb: 3,
                            flexWrap: "wrap",
                            gap: 2,
                            flexDirection: { xs: "column", md: "row" }
                        }}
                    >
                        <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 3 }}>Student Details </Typography>
                        <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap", width: { xs: "100%", md: "auto" } }}  >
                            <Button variant="contained" sx={{
                                borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                                '&:hover': { backgroundColor: '#3A3897', },
                            }} onClick={() => {
                                const defaultRoleId = roleData[0]?._id || '';
                                const defaultRoleName = roleData[0]?.role_name || 'Students';
                                setFormData({
                                    firstName: '', lastName: '', email: '', phone: '', employee_id: '', adhaar: '',
                                    password: '', confirmPassword: '', department_id: null, college_id: '', role_id: defaultRoleId
                                });
                                setUserType(defaultRoleName);
                                setErrors([]);
                                addStudentShowModal(true);
                            }} > + Add Students </Button>

                            {/* Import Excel */}
                            <input
                                type="file"
                                accept=".xlsx,.xls"
                                style={{ display: "none" }}
                                id="upload-excel"
                                onChange={handleExcelUpload}
                            />
                            <label htmlFor="upload-excel">
                                <Button variant="outlined" component="span" startIcon={<UploadFileIcon />}
                                    sx={{ borderRadius: 2, fontWeight: 600, textTransform: 'none' }}>
                                    Import Excel
                                </Button>
                            </label>

                            {/* <Button
                                variant="contained"
                                startIcon={<DownloadIcon />}
                                onClick={handleExportCSV}
                                sx={{
                                    borderRadius: 2,
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    backgroundColor: '#00897B',
                                    height: 40,
                                    '&:hover': { backgroundColor: '#00695C' }
                                }}
                            >
                                Export CSV
                            </Button> */}
                            <Button
                                variant="contained"
                                startIcon={!exportLoading && <DownloadIcon />}
                                onClick={handleExportAllCSV}
                                disabled={exportLoading}
                                sx={{
                                    borderRadius: 2,
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    backgroundColor: '#FF9800',
                                    height: 40
                                }}
                            >
                                {exportLoading ? "Exporting..." : "Export CSV"}
                            </Button>
                        </Box>
                    </Box>

                    {excelImportStatus ? (
                        <Alert severity="info" sx={{ mb: 2 }}>{excelImportStatus}</Alert>
                    ) : null}

                    {/* Header: Add Button (left) and Search (right) */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: { xs: 'stretch', md: 'center' },
                            mb: 2,
                            flexWrap: 'wrap',
                            gap: 2,
                            flexDirection: { xs: 'column', md: 'row' }
                        }}
                    >
                        <Box sx={{ display: "flex", gap: 2, alignItems: 'center', flexWrap: 'wrap', width: { xs: "100%", md: "auto" } }}>
                            <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 150 } }}>
                                <InputLabel>College</InputLabel>
                                <Select
                                    value={selectedCollege}
                                    label="College"
                                    onChange={(e) => {
                                        setSelectedCollege(e.target.value);
                                        setPage(1);
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    {collegeData.map((college) => (
                                        <MenuItem key={college._id} value={college._id}>
                                            {college.collegeName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl
                                size="small"
                                sx={{
                                    minWidth: { xs: "100%", sm: 150 },
                                    height: 40,
                                    backgroundColor: "#fff",
                                    borderRadius: 2,
                                    boxShadow: "0px 0px 6px #00000014"
                                }}
                            >
                                <InputLabel>Progress</InputLabel>
                                <Select value={progressFilter} label="Progress"
                                    onChange={(e) => {
                                        setProgressFilter(e.target.value);
                                        setPage(1);
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="Not Started">Not Started</MenuItem>
                                    <MenuItem value="In Progress">In Progress</MenuItem>
                                    <MenuItem value="Completed">Completed</MenuItem>
                                </Select>
                            </FormControl>

                            {/* Status Filter */}
                            <FormControl
                                size="small"
                                sx={{
                                    minWidth: { xs: "100%", sm: 150 },
                                    height: 40,
                                    justifyContent: "center",
                                    backgroundColor: "#fff",
                                    borderRadius: 2,
                                    boxShadow: "0px 0px 6px #00000014"
                                }}
                            >
                                <InputLabel>Status</InputLabel>
                                <Select
                                    value={statusFilter}
                                    label="Status"
                                    onChange={(e) => {
                                        setStatusFilter(e.target.value);
                                        setPage(1);
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="true">Approved</MenuItem>
                                    <MenuItem value="false">Unapproved</MenuItem>
                                </Select>
                            </FormControl>

                            {/* <FormControl size="small"
                                sx={{
                                    minWidth: 160, height: 40, justifyContent: "center", backgroundColor: "#fff",
                                    borderRadius: 2, boxShadow: "0px 0px 6px #00000014"
                                }} >
                                <InputLabel>Month</InputLabel>
                                <Select
                                    value={monthFilter}
                                    label="month"
                                    onChange={(e) => {
                                        setMonthFilter(e.target.value);
                                        setPage(1);
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="1">Jan</MenuItem>
                                    <MenuItem value="2">Feb</MenuItem>
                                    <MenuItem value="3">Mar</MenuItem>
                                    <MenuItem value="4">Apr</MenuItem>
                                    <MenuItem value="5">May</MenuItem>
                                    <MenuItem value="6">Jun</MenuItem>
                                    <MenuItem value="7">Jul</MenuItem>
                                    <MenuItem value="8">Aug</MenuItem>
                                    <MenuItem value="9">Sep</MenuItem>
                                    <MenuItem value="10">Oct</MenuItem>
                                    <MenuItem value="11">Nov</MenuItem>
                                    <MenuItem value="12">Dec</MenuItem>
                                </Select>
                            </FormControl> */}

                            <FormControl size="small"
                                sx={{
                                    minWidth: { xs: "100%", sm: 150 }, height: 40, justifyContent: "center", backgroundColor: "#fff",
                                    borderRadius: 2, boxShadow: "0px 0px 6px #00000014"
                                }} >
                                <InputLabel>Year</InputLabel>
                                <Select
                                    value={yearFilter}
                                    label="year"
                                    // onChange={(e) => {
                                    //     setYearFilter(e.target.value);
                                    //     setPage(1);
                                    // }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setYearFilter(value);
                                        setPage(1);

                                        if (!value) {
                                            setMonthFilter(''); // ✅ reset month
                                        }
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="2023">2023</MenuItem>
                                    <MenuItem value="2024">2024</MenuItem>
                                    <MenuItem value="2025">2025</MenuItem>
                                    <MenuItem value="2026">2026</MenuItem>
                                </Select>
                            </FormControl>


                            <Tooltip title={!yearFilter ? "Please select the year first" : ""}>
                                <span>
                                    <FormControl
                                        size="small"
                                        disabled={!yearFilter}
                                        sx={{
                                            minWidth: { xs: "100%", sm: 150 },
                                            height: 40,
                                            justifyContent: "center",
                                            backgroundColor: "#fff",
                                            borderRadius: 2,
                                            boxShadow: "0px 0px 6px #00000014"
                                        }}
                                    >
                                        <InputLabel>Month</InputLabel>

                                        <Select
                                            value={monthFilter}
                                            label="Month"
                                            onChange={(e) => {
                                                setMonthFilter(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <MenuItem value="">All</MenuItem>
                                            <MenuItem value="1">Jan</MenuItem>
                                            <MenuItem value="2">Feb</MenuItem>
                                            <MenuItem value="3">Mar</MenuItem>
                                            <MenuItem value="4">Apr</MenuItem>
                                            <MenuItem value="5">May</MenuItem>
                                            <MenuItem value="6">Jun</MenuItem>
                                            <MenuItem value="7">Jul</MenuItem>
                                            <MenuItem value="8">Aug</MenuItem>
                                            <MenuItem value="9">Sep</MenuItem>
                                            <MenuItem value="10">Oct</MenuItem>
                                            <MenuItem value="11">Nov</MenuItem>
                                            <MenuItem value="12">Dec</MenuItem>
                                        </Select>
                                    </FormControl>
                                </span>
                            </Tooltip>


                            <Button
                                variant="contained"
                                onClick={() => clearFilters()}
                                sx={{
                                    borderRadius: 2,
                                    fontWeight: 600,
                                    px: 3,
                                    py: 1,
                                    textTransform: 'none',
                                    backgroundColor: '#c9c9d1',
                                    boxShadow: 2,
                                    height: 40,
                                    width: { xs: "100%", sm: "auto" },
                                    '&:hover': { backgroundColor: '#9393af' }
                                }}
                            >
                                × Clear
                            </Button>
                        </Box>

                        {/* <TextField placeholder="Search" value={searchQuery} onChange={handleSearchChange} variant="outlined" size="medium"
                            sx={{ width: { xs: "100%", sm: 350 }, bgcolor: '#e9ecef', borderRadius: 2, '& .MuiOutlinedInput-root': { borderRadius: 2, }, }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: '#757575' }} />
                                    </InputAdornment>
                                ),
                                sx: { bgcolor: '#e9ecef', borderRadius: 2 },
                            }}
                        /> */}


                        {/* RIGHT SIDE (Search) */}
                        <TextField placeholder="Search Students" value={searchQuery}
                            onChange={handleSearchChange} variant="outlined" size="small"
                            sx={{
                                width: { xs: "100%", sm: 185 },
                                bgcolor: '#f5f6fa',
                                borderRadius: 2,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 2,
                                    height: 40
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: '#757575' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />

                    </Box>

                    {/* Table */}
                    <TableContainer
                        component={Paper}
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            overflowX: "auto",
                            overflowY: "hidden",
                            "&::-webkit-scrollbar": {
                                height: "8px"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#888",
                                borderRadius: "4px"
                            }
                        }}
                    >
                        {/* <TableContainer component={Paper} elevation={0} sx={{ mb: 2, borderRadius: 2, boxShadow: 2, overflow: 'hidden', }} > */}
                        <Table size="small" sx={{ minWidth: 1200, "& .MuiTableCell-root": { py: 1 } }}>
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#4B49AC' }}>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopLeftRadius: 8 }}> ID </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Full Name  </TableCell>
                                    {/* <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Last name </TableCell> */}
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Email </TableCell>
                                    {/* <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Phone </TableCell> */}
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Students Id </TableCell>
                                    {/* <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Role </TableCell> */}
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> College </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Enrollment Month </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Enrollment Year </TableCell>
                                    {/* <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Department </TableCell> */}
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Status </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Progress Status </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Course Progress </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Assessment Percentage </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopRightRadius: 8 }}> Action </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((item, index) => (
                                    <TableRow key={item._id}>
                                        <TableCell align="center">
                                            <Typography variant="body1">{(page - 1) * rowsPerPage + index + 1}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.firstName} {item.lastName}</Typography>
                                        </TableCell>
                                        {/* <TableCell align="center">
                                            <Typography variant="body1">{item.lastName}</Typography>
                                        </TableCell> */}
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.email}</Typography>
                                        </TableCell>
                                        {/* <TableCell align="center">
                                            <Typography variant="body1">{item.phone}</Typography>
                                        </TableCell> */}
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.employee_id}</Typography>
                                        </TableCell>
                                        {/* <TableCell align="center">
                                            <Typography variant="body1">{item.role_id?.role_name}</Typography>
                                        </TableCell> */}
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.college_id?.collegeName}</Typography>
                                        </TableCell>

                                        <TableCell align="center">
                                            <Typography variant="body1">
                                                {new Date(item.createdAt).toLocaleString('default', { month: 'long' })}
                                            </Typography>
                                        </TableCell>

                                        <TableCell align="center">
                                            <Typography variant="body1">
                                                {new Date(item.createdAt).getFullYear()}
                                            </Typography>
                                        </TableCell>
                                        {/* <TableCell align="center">
                                            <Typography variant="body1">{item.department_id?.name}</Typography>
                                        </TableCell> */}
                                        <TableCell align="center">
                                            <Switch
                                                checked={item.isApproved || false}
                                                onChange={() => handleStatusChange(item._id, !item.isApproved)}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        color: '#4caf50',
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: '#4caf50',
                                                    },
                                                    '& .MuiSwitch-switchBase': {
                                                        color: '#f44336',
                                                    },
                                                    '& .MuiSwitch-track': {
                                                        backgroundColor: '#f44336',
                                                    },
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    color:
                                                        item.progressStatus === "Completed"
                                                            ? "green"
                                                            : item.progressStatus === "In Progress"
                                                                ? "orange"
                                                                : "red",
                                                    fontWeight: 600
                                                }}
                                            >
                                                {item.progressStatus}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.progressPercentage}%</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.quizPercentage}%</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton color="primary" onClick={() => editStudent(item._id)}>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton color="error" onClick={() => deleteStudent(item._id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Pagination */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: { xs: 'center', md: 'flex-end' },
                            alignItems: 'center',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 1,
                            width: '100%'
                        }}
                    >
                        <Pagination count={totalPages} page={page} onChange={handlePageChange} shape="rounded"
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    '&.Mui-selected': {
                                        bgcolor: '#4B49AC',
                                        color: 'white',
                                    },
                                },
                            }}
                        />
                        <Select value={rowsPerPage} onChange={handleRowsPerPageChange} size="small"
                            sx={{ ml: 2, height: 35, bgcolor: '#f7f7f7', border: '1px solid #e2e2e2', '& .MuiSelect-select': { py: 0.75 }, }}
                            IconComponent={KeyboardArrowDownIcon} >
                            <MenuItem value={10}>10 / page</MenuItem>
                            <MenuItem value={20}>20 / page</MenuItem>
                            <MenuItem value={50}>50 / page</MenuItem>
                        </Select>
                    </Box>
                </Box>
            }
            {/* Add Student */}
            <Modal open={showStudentModal} onClose={handleAddStudentModalClose} aria-labelledby="add-college-modal">
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: { xs: '95vw', sm: 900 }, maxHeight: '90vh', overflow: 'auto', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2, }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h2">
                            Add Student
                        </Typography>
                        <IconButton onClick={() => addStudentShowModal(false)}
                            sx={{ position: 'absolute', right: 8, top: 8, color: 'gray' }} >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <form onSubmit={addStudent}>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label={<>First Name <span style={{ color: 'red' }}>*</span> </>} name="firstName" value={formData.firstName} onChange={handleInputChange}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.firstName} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="Last Name" name="lastName" value={formData.lastName} onChange={handleInputChange}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.lastName} />
                            </Box>

                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>Role<span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Select name="role_id" value={formData.role_id} onChange={handleInputChange} label="College" >
                                        {roleData.map((role) => (
                                            <MenuItem key={role._id} value={role._id}>
                                                {role.role_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <ErrorMessage error={errors.role_id} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label={<>Email <span style={{ color: 'red' }}>*</span> </>} name="email" value={formData.email} onChange={handleInputChange}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.email} />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label={<>Phone <span style={{ color: 'red' }}>*</span> </>} name="phone" value={formData.phone} onChange={handleInputChange}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.phone} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label={<>{userType === 'Students' ? 'Enrollment Number (Username)' : 'Employee ID'}<span style={{ color: 'red' }}>*</span></>}
                                    name="employee_id" value={formData.employee_id} onChange={handleInputChange}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.employee_id} />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>College<span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Select name="college_id" value={formData.college_id} onChange={handleInputChange} label="College" >
                                        {collegeData.map((college) => (
                                            <MenuItem key={college._id} value={college._id}>
                                                {college.collegeName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <ErrorMessage error={errors.college_id} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label={<>Adhaar <span style={{ color: 'red' }}>*</span> </>} name="adhaar" value={formData.adhaar} onChange={handleInputChange}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.adhaar} />
                            </Box>
                            {/* <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>Department</InputLabel>
                                    <Select name="department_id" value={formData.department_id} onChange={handleInputChange} label="Department" >
                                        {DepartmentData.map((department) => (
                                            <MenuItem key={department._id} value={department._id}>
                                                {department.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <ErrorMessage error={errors.department_id} />
                            </Box> */}
                        </Box>

                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label='Affiliated College Name' name="affiliatedCollegeName" value={formData.affiliatedCollegeName} onChange={handleInputChange} margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.affiliatedCollegeName} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label='Affiliated College Code' name="affiliatedCollegeCode" value={formData.affiliatedCollegeCode} onChange={handleInputChange} margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.affiliatedCollegeCode} />
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>Gender<span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Select name="gender" value={formData.gender} onChange={handleInputChange} label="Gender" >
                                        <MenuItem value="male">Male</MenuItem>
                                        <MenuItem value="female">Female</MenuItem>
                                        <MenuItem value="other">Other</MenuItem>
                                    </Select>
                                </FormControl>
                                <ErrorMessage error={errors.gender} />
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>

                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth type="password" label={<>Password <span style={{ color: 'red' }}>*</span> </>} name="password" value={formData.password}
                                    onChange={handleInputChange} margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.password} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth type="password" label={<> Confirm Password <span style={{ color: 'red' }}>*</span> </>} name="confirmPassword"
                                    value={formData.confirmPassword} onChange={handleInputChange} margin="normal" sx={{ flex: 1 }} />
                            </Box>
                        </Box>
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button variant="contained" sx={{
                                borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                                '&:hover': { backgroundColor: '#3A3897', },
                            }} type="submit"> Save
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>

            {/* Student update model */}
            <Modal open={updateStudentModalShow} onClose={handleUpdateStudentModalClose} aria-labelledby="update-college-modal" >
                <Box sx={{
                    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 900,
                    width: { xs: '95vw', sm: 900 },
                    maxHeight: '90vh',
                    overflow: 'auto',
                    bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2,
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h2">
                            Update Student
                        </Typography>
                        <IconButton onClick={() => updateStudentModal(false)} sx={{ position: 'absolute', right: 8, top: 8, color: 'gray' }} >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <form>
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="First Name" name="firstName" value={selectedStudent?.firstName || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent, firstName: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.firstName} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="Last Name" name="lastName" value={selectedStudent?.lastName || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent, lastName: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.firstName} />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="Email" name="email" value={selectedStudent?.email || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent, email: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.email} />
                            </Box>
                            {/* <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="Phone" name="phone" value={selectedStudent?.phone || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent?.admin, phone: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.phone} />
                            </Box> */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="Phone" name="phone" value={selectedStudent?.phone || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent, phone: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.phone} />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="Adhaar Number" name="adhaar" value={selectedStudent?.adhaar || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent, adhaar: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.adhaar} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label={<>{selectedStudent?.role_id?.role_name === 'Students' ? 'Enrollment Number (Username)' : 'Employee ID'}<span style={{ color: 'red' }}>*</span></>} name="employee_id" value={selectedStudent?.employee_id || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent, employee_id: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} InputProps={{ readOnly: true }} />
                                <ErrorMessage error={errors.employee_id} />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                    <FormControl fullWidth margin="normal">
                                        <InputLabel>Gender</InputLabel>

                                        <Select
                                            name="gender"
                                            value={selectedStudent?.gender || ""}
                                            onChange={(e) =>
                                                setSelectedStudent({
                                                    ...selectedStudent,
                                                    gender: e.target.value
                                                })
                                            }
                                            label="Gender"
                                        >
                                            <MenuItem value="male">Male</MenuItem>
                                            <MenuItem value="female">Female</MenuItem>
                                            <MenuItem value="other">Other</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <ErrorMessage error={errors.gender} />
                                </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>College</InputLabel>
                                    <Select name="college_id" value={selectedStudent?.college_id?._id || selectedStudent?.college_id || ""}
                                        onChange={(e) => {
                                            setSelectedStudent({ ...selectedStudent, college_id: e.target.value });
                                            getDepartmentsByCollege(e.target.value);
                                            // Clear department selection when college changes
                                            setSelectedStudent(prev => ({ ...prev, department_id: '' }));
                                        }} label="College" >
                                        {collegeData.map((college) => (
                                            <MenuItem key={college._id} value={college._id}>
                                                {college.collegeName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            {/* <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>Department</InputLabel>
                                    <Select name="department_id" value={selectedStudent?.department_id?._id || selectedStudent?.department_id || null}
                                        onChange={(e) => { setSelectedStudent({ ...selectedStudent, department_id: e.target.value }); }} label="College" >
                                        {DepartmentData.map((department) => (
                                            <MenuItem key={department._id} value={department._id}>
                                                {department.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box> */}
                        </Box>
                        {/* <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>College</InputLabel>
                                    <Select name="role_id" value={selectedStudent?.role_id?._id || selectedStudent?.role_id || ""}
                                        onChange={(e) => { setSelectedStudent({ ...selectedStudent, role_id: e.target.value }); }} label="College" >
                                        {roleData.map((role) => (
                                            <MenuItem key={role._id} value={role._id}>
                                                {role.role_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box> */}

                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="Affiliated College Name" name="affiliatedCollegeName" value={selectedStudent?.affiliatedCollegeName || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent, affiliatedCollegeName: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.affiliatedCollegeName} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <TextField fullWidth label="Affiliated College Code" name="affiliatedCollegeCode" value={selectedStudent?.affiliatedCollegeCode || ""}
                                    onChange={(e) => setSelectedStudent({ ...selectedStudent, affiliatedCollegeCode: e.target.value })}
                                    margin="normal" sx={{ flex: 1 }} />
                                <ErrorMessage error={errors.affiliatedCollegeCode} />
                            </Box>
                        </Box>
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button variant="contained" sx={{
                                borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC', '&:hover': { backgroundColor: '#3A3897', },
                            }} onClick={updateStudent}>
                                Save changes
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>
        </Layout>
    );
};

export default Users;